<template>
  <div class="regular-header">
  <navbar />

  <halfBanner>
    <template v-slot:intro-tekst>
      <h1>Gowallet</h1>
      <p>Met GoWallet spaar je niet alleen punten waar je zelf leuke beloningen mee kunt verdienen, je steunt ook nog eens een kind in Nederland dat onder de armoedegrens leeft. Kost jou niks, levert de kinderen een heleboel op. Wij verzorgden de <a>rebranding</a> en het <a>product design</a> voor deze maatschappelijk bewuste onderneming met het hart op de juiste plek.</p>
      <a v-scroll-to="'#contact'">Read more!</a>
    </template>

    <template v-slot:intro-animation>
        <div class="intro-animation">
          <lottie :options="headerImages[0].defaultOptions"/>   
          <a> {{ headerImages[headerIndex].string }}  </a>
        </div>
    </template>
  </halfBanner>  

  <div class="case-page">

  <titel>
    <template v-slot:intro-tekst>
      <h2>Rebranding GoWallet</h2>
      <p>De focus van GoWallet is in de loop de jaren iets veranderd. Het is het niet meer dan logisch om dat ook naar voren te laten komen in een nieuw jasje! De visie van GoWallet verdiende een solide visuele basis die aansluit op wat de doelgroep verwacht maar zeker ook mag verrassen.</p>
    </template>
  </titel>

  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case odd">
      <div class="img-box">
        <img src="../../assets/cases/gowallet/Folded_Paper_Werk_Gowallet_image_1.jpg">
      </div>
      <div class="text-box">
        <div class="content padding-left">
          <h3>Dat mag wel wat frisser</h3>
          <p>Sparen hoort leuk te zijn. Het merk moet er voor zorgen dat de actie van het sparen alleen maar leuker gaat worden. Met het goede doel in ons achterhoofd, kinderen onder de armoedegrens een leuke dag laten beleven, zijn we voor een bold kleurenpalet gegaan wat energiek en activerend is. Dit in combinatie met een sierlijk en speels font dat leesbaar is voor zowel grote announcements op banners als micro-copy in een applicatie.</p>
        </div>
      </div>
    </div>
  </oddEvenGrid>

    <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case even">
      <div class="text-box">
        <div class="content padding-right">
          <h3>Twee logo’s, één gezamenlijk doel</h3>
          <p>GoWallet richt haar pijlen op twee doelgroepen. De merchant die zijn winkel aan kan melden bij de loyaliteitsservice van GoWallet en de consumenten die bij aangesloten winkels sparen. Daarom hebben wij twee nieuwe logo’s ontwikkeld die gericht zijn op deze doelgroepen.</p>
        </div>
      </div>
      <div class="img-box">
        <img src="../../assets/cases/gowallet/Folded_Paper_Werk_Gowallet_image_2.jpg">
      </div>
    </div>
  </oddEvenGrid>

  <oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case odd">
      <div class="img-box">
        <img src="../../assets/cases/gowallet/Folded_Paper_Werk_Gowallet_image_3.jpg">
      </div>
      <div class="text-box">
        <div class="content padding-left">
          <h3>Become a superhero!</h3>
          <p>De gebruikers van de app horen het gevoel te krijgen dat zij superhelden zijn. Zij helpen namelijk de kinderen die leven onder de armoedegrens. Om dit gevoel te versterken hebben wij een mascotte in het leven geroepen voor GoWallet. Deze mascotte staat voor iedere gebruiker die zich aansluit bij het loyaliteitsprogramma. </p>
        </div>
      </div>
    </div>
  </oddEvenGrid>

<fullWidthPicture v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
  <template v-slot:case-img>
    <img src="../../assets/cases/gowallet/Folded_Paper_Werk_Gowallet_image_4.jpg">
  </template>
</fullWidthPicture>

<titelPictureMedium v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
   <template v-slot:intro-tekst>
    <h3>Laat het merk tot leven komen!</h3>
    <p>In de illustratiereeks die wij ontwikkeld hebben voor GoWallet laten we zien hoe belangrijk hun rol is in dit verhaal. Deze illustraties bevestigen ook het overkoepelende concept dat GoWallet een win - win situatie is voor zowel de ondernemer als het goede doel. Onderstaand zie je een greep uit enkele illustraties en animaties die wij voor GoWallet ontwikkeld hebben.</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/cases/gowallet/Folded_Paper_Werk_Gowallet_image_5.jpg">
  </template>
</titelPictureMedium>

<pictureTrio v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
   <template v-slot:case-img>
    <img src="../../assets/cases/gowallet/Folded_Paper_Gowallet_gif1.gif">
    <img src="../../assets/cases/gowallet/Folded_Paper_Gowallet_gif2.gif">
    <img src="../../assets/cases/gowallet/Folded_Paper_Gowallet_gif3.gif">
  </template>

</pictureTrio>

<titelPictureBig v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
  <template v-slot:intro-tekst>
    <h2>Het spaargeraamte</h2>
    <p>Een spaarapplicatie kan nog best complex zijn. Voordat we aan een gelikt user interface kunnen beginnen hoort er een solide basis te staan. Hierin schetsen wij de structuur en de userflow voor de gehele applicatie zodat deze voor iedere gebruiker natuurlijk aanvoelt. </p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/cases/gowallet/Folded_Paper_Werk_Gowallet_image_6.jpg">
  </template>
</titelPictureBig>

<titel v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
  <template v-slot:intro-tekst>
    <h2>App je deze al gezien?</h2>
    <p>Van de ruim 60 schermen die wij uiteindelijk ontworpen hebben voor GoWallet lichten wij hier graag een aantal key features uit van de applicatie. Deze geven de gebruiker emotie mee, houden de gebruiker op het platform en maken het vooral leuk om dag in dag uit te gebruiken.</p>
  </template>
</titel>

<oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case odd">
      <div class="img-box">
        <img src="../../assets/cases/gowallet/Folded_Paper_Werk_Gowallet_image_7.jpg">
      </div>
      <div class="text-box">
        <div class="content padding-left">
          <h3>Iedereen aan boord</h3>
          <p>Om gebruikers te introduceren aan de fonkelnieuwe spaarapplicatie van GoWallet hebben wij een serie onboarding screens ontworpen die het doel van GoWallet omschrijven. Ondersteunend aan de copy zijn er illustraties ontwikkeld die de boodschap van de app en het overkoepelende verhaal nog duidelijker overbrengen.</p>
        </div>
      </div>
    </div>
</oddEvenGrid>

<oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case even">
      <div class="text-box">
        <div class="content padding-right">
          <h3>Gotta catch ‘em all</h3>
          <p>Middels gamification elementen stimuleren wij gebruikers terug te keren naar het spaarprogramma van GoWallet. Bij elke X aantal punten of gedoneerde cadeau’s aan de Kinderen van de Voedselbank verdienen gebruikers punten om vervolgens badges te unlocken. Dit zorgt voor een positieve feedback loop en laat de gebruikers visueel zien dat ze bijdragen aan het geluk van een kind onder de armoede grens.</p>
        </div>
      </div>
      <div class="img-box">
        <img src="../../assets/cases/gowallet/Folded_Paper_Werk_Gowallet_image_8.jpg">
      </div>
    </div>
</oddEvenGrid>

<oddEvenGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
    <div class="odd-even-grid case odd">
      <div class="img-box">
        <img src="../../assets/cases/gowallet/Folded_Paper_Werk_Gowallet_image_9.jpg">
      </div>
      <div class="text-box">
        <div class="content padding-left">
          <h3>Scan jij ‘m al?</h3>
          <p>Scannen is het hart van de applicatie. Zonder deze functionaliteit kan er voor zowel de gebruiker als het kind in armoede niet worden gespaard. Middels een offline transactiebon die de merchant uit kan draaien scant de gebruiker zijn of haar uitgaven. Deze worden slim omgezet in punten waar de superheld zowel voor zichzelf als iemand anders kan sparen.</p>
        </div>
      </div>
    </div>
</oddEvenGrid>

<endCase v-scroll-reveal="{ delay: 550, viewFactor: 0.5}"> 
  <template v-slot:intro-tekst>
    <h2>Gowallet samengevat</h2>
    <p>De eerste versie van de applicatie draait nu een pilot bij selecte horeca ondernemingen en we houden in de gaten wat de ontwikkelingen zijn op gebied van gamification om zo het platform steeds meer body te kunnen geven.</p>
  </template>
  <template v-slot:case-img>
    <img src="../../assets/Folded_Paper_Werk_Thanks.jpg">
  </template>
  <template v-slot:outro-tekst>
    <h4>Bekijk ook onze andere toffe cases</h4>
  </template>
</endCase>

 <caseGrid v-scroll-reveal="{ delay: 550, viewFactor: 0.1}"> 
    <div class="row">
      <ul>
        <li>
          <router-link class="router-link" to="/werk/wageningen-universiteit">
            <div class="column tca">
              <img src="../../assets/Folded_Paper_case_thumnail_Unlock.jpg">
              <span class="font-size-custom-max-12">Unlock Wageningen Universiteit & Research<br>Branding & product design</span>
            </div>
           </router-link>
        </li>

        <li>
          <router-link class="router-link" to="/werk/avans-hogeschool">
            <div class="column avans">
              <img src="../../assets/Folded_Paper_case_thumbnail_Avans_Hogeschool.jpg">
              <span class="font-size-custom-max-12">Avans Hogeschool<br>Product design</span>
            </div>
          </router-link>
        </li>
    </ul>
  </div>
</caseGrid>

</div>
<footerComponent></footerComponent>

</div>

</template>

<script>
import navbar from '@/components/generalLayout/navbar.vue';
import halfBanner from '@/components/generalLayout/halfBanner.vue';
import titel from '@/components/generalLayout/werk/titel.vue';
import oddEvenGrid from '@/components/generalLayout/oddEvenGrid.vue';
import titelPictureMedium from '@/components/generalLayout/werk/titelPictureMedium.vue';
import titelPictureBig from '@/components/generalLayout/werk/titelPictureBig.vue';
import pictureTrio from '@/components/generalLayout/werk/pictureTrio.vue';
import endCase from '@/components/generalLayout/werk/endCase.vue';
import fullWidthPicture from '@/components/generalLayout/werk/fullWidthPicture.vue';
import caseGrid from '@/components/generalLayout/caseGrid.vue';
import footerComponent from '@/components/specificLayout/footerComponent.vue';


import Lottie from '../../lottie.vue';
import * as animationGowallet from '@/assets/cases/gowallet/headeranimatie/gowallet.json';


export default {
  data () {
    return {
      headerImages: [
	      { defaultOptions: {animationData: animationGowallet.default}, string:'Branding / UX design / UI design / Illustratie / Animatie'},
      ],
    }
  },
  components:{
    navbar,
    halfBanner,
    titel,
    oddEvenGrid,
    titelPictureMedium,
    titelPictureBig,
    pictureTrio,
    endCase,
    fullWidthPicture,
    caseGrid,
    footerComponent,
    'lottie': Lottie,
  },

  methods:{
    randomNumber(maxValue){
      return Math.floor(Math.random() * Math.floor(maxValue));
    }
  },
  computed:{
    headerIndex(){
      return this.randomNumber(this.headerImages.length);
    }
  },
}

</script>

<style lang="scss">

.home-bg-color{
  background: rgba(251,210,118,0.15) !important;
  background-repeat: no-repeat;
  background-size: cover;
}

.fold-container .first-content .intro-tekst{
  animation-delay: 1.4s;
}

.regular-header .fold-container .home-bg-color{
  animation-delay: .6s;
}

.regular-header .fold-container .case-hightlight-img .intro-animation{
  animation-delay: 1s;
}

body .case .img-box img, .odd-even-grid .text-box img{
  max-height: 600px !important;
  width: auto !important;
  margin:  auto;
  display: block;
}

.case-content{
  h2{
    padding-top: layout-val-64(0.5);
    padding-bottom: layout-val-8(1);
  }
}

.case-img-bg{
  background-color: #FFF8E7;
}


@media screen and (max-width: 720px) {
  .content-grid-two-rows{
    .firstenergy, .loud, .newschain, .tca{
      float: none;
    }
  }
}

@media screen and (max-width: 640px) {
  body .case .img-box img, .odd-even-grid .text-box img{
    max-width: 90% !important;
  }
  .home-bg-color{
    width: 100% !important;
    max-width: 100% !important;
    left:12px;
    border-right: 24px solid $white !important;
  }
}
</style>
